function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Select from "react-select";
import { connect } from 'react-redux';
import _ from "lodash";
import { isNew } from "../../../../helpers/objectUtils";
import TmSelectBadgedNewLabel from "./TmSelectBadgedNewLabel";

class TmReactSelect extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleChange", selectedOption => {
      if (!!selectedOption && !!selectedOption.label && !!selectedOption.label.props) {
        selectedOption = { ...selectedOption,
          label: selectedOption.label.props.children
        };
      }

      this.props.afterChange(selectedOption);
    });

    _defineProperty(this, "render", () => {
      const {
        field,
        options,
        forcedOptions,
        hasAppend,
        afterChange,
        required,
        disableClear,
        dynamicEdit,
        target,
        filterOption,
        ...config
      } = this.props;
      const containerWidth = hasAppend ? 'calc(100% - 2.5rem)' : '100%';
      const isClearable = !!dynamicEdit ? true : !!required ? false : !!!disableClear;
      return /*#__PURE__*/React.createElement(Select, _extends({
        name: field,
        options: forcedOptions || _.map(Object.values(this.props.options), option => {
          return !!option.id && isNew(option) ? { ...option,
            label: /*#__PURE__*/React.createElement(TmSelectBadgedNewLabel, null, option.label)
          } : option;
        }),
        onChange: this.handleChange,
        className: 'react-select',
        target: target,
        styles: this.props.darkMode ? {
          clearIndicator: styles => ({ ...styles,
            ':hover': {
              color: '#e3eaef'
            }
          }),
          container: () => ({
            width: containerWidth
          }),
          control: styles => ({ ...styles,
            background: '#404752',
            border: '1px solid #4d5764',
            borderRadius: '.25rem'
          }),
          dropdownIndicator: styles => ({ ...styles,
            ':hover': {
              color: '#e3eaef'
            }
          }),
          input: styles => ({ ...styles,
            background: '#404752',
            color: '#e3eaef'
          }),
          singleValue: styles => ({ ...styles,
            background: '#404752',
            color: '#e3eaef',
            width: '95%'
          }),
          multiValue: styles => ({ ...styles,
            background: '#333940',
            color: '#e3eaef'
          }),
          multiValueLabel: styles => ({ ...styles,
            background: '#333940',
            color: '#e3eaef'
          }),
          menu: styles => ({ ...styles,
            background: '#404752',
            color: '#e3eaef',
            zIndex: 999
          }),
          indicatorSeparator: styles => ({ ...styles,
            background: '#4d5764'
          }),
          option: (base, state) => ({ ...base,
            backgroundColor: '#404752',
            ':hover': {
              backgroundColor: '#282f39 !important'
            }
          }),
          groupHeading: styles => ({ ...styles,
            fontSize: '1rem'
          })
        } : {
          container: () => ({
            width: containerWidth
          }),
          control: styles => ({ ...styles,
            border: '1px solid #dee2e6',
            borderRadius: '.25rem'
          }),
          menu: styles => ({ ...styles,
            zIndex: 999
          }),
          option: (base, state) => ({ ...base,
            color: '#4e555d',
            backgroundColor: '#ffffff',
            ':hover': {
              backgroundColor: '#e0e1e6'
            }
          })
        },
        isClearable: isClearable
      }, config, {
        filterOption: ({
          label,
          value,
          data
        }, search) => {
          if (filterOption) {
            return filterOption({
              label,
              value,
              data
            }, search);
          }

          let candidate = !!label && !!label.props ? label.props.children : label;
          search = search.toLowerCase();
          candidate = candidate.toLowerCase();
          return candidate.indexOf(search) > -1;
        }
      }));
    });
  }

}

function mapStateToProps(state) {
  return {
    darkMode: state.layout.darkMode
  };
}

export default connect(mapStateToProps, {})(TmReactSelect);